import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/autoreponders`;

export const getAutoresponders = (guildId) => apiRequest(base(guildId));
export const createAutoresponder = (guildId, payload) =>
  apiRequest(base(guildId), { method: "POST", body: payload });
export const updateAutoresponder = (guildId, id, payload) =>
  apiRequest(`${base(guildId)}/${id}`, { method: "PATCH", body: payload });
export const deleteAutoresponder = (guildId, trigger) =>
  apiRequest(`${base(guildId)}/${encodeURIComponent(trigger)}`, { method: "DELETE" });
export const toggleAutoresponder = (guildId, id) =>
  apiRequest(`${base(guildId)}/${id}/toggle`, { method: "POST" });
